module.exports = __webpack_public_path__ + "static/media/filo3.0d1f8250.png";